const breakpoint = window.matchMedia('(max-width: 700px)');


/* Cart Page */


const copyStudent = (e, id, outputId) => {

	if (e) e.preventDefault();
	// const studentId = id ? Number(id) : 1;
	studentId = id;
	const registrationForm = document.querySelector("#registrationForm");

	if (!registrationForm) return;

	// const outputStudentId = outputId ? Number(outputId) : Number(studentId) + 1;
	const outputStudentId = outputId;

	const first = registrationForm.querySelector(`#first-name-${studentId}`);
	const last = registrationForm.querySelector(`#last-name-${studentId}`);
	const email = registrationForm.querySelector(`#customer-email-${studentId}`);
	const phone = registrationForm.querySelector(`#customer-phone-${studentId}`);

	const firstOutput = registrationForm.querySelector(`#first-name-${outputStudentId}`);
	const lastOutput = registrationForm.querySelector(`#last-name-${outputStudentId}`);
	const emailOutput = registrationForm.querySelector(`#customer-email-${outputStudentId}`);
	const phoneOutput = registrationForm.querySelector(`#customer-phone-${outputStudentId}`);

	if (!firstOutput) return;

	firstOutput.value = first.value;
	firstOutput.dispatchEvent(new Event('change', { 'bubbles': true }))
	themeActions.setLocalStorage(firstOutput.id || firstOutput.name, first.value);

	lastOutput.value = last.value;
	lastOutput.dispatchEvent(new Event('change', { 'bubbles': true }))
	themeActions.setLocalStorage(lastOutput.id || lastOutput.name, last.value);

	emailOutput.value = email.value;
	emailOutput.dispatchEvent(new Event('change', { 'bubbles': true }))
	themeActions.setLocalStorage(emailOutput.id || emailOutput.name, email.value);

	phoneOutput.value = phone.value;
	phoneOutput.dispatchEvent(new Event('change', { 'bubbles': true }))
	themeActions.setLocalStorage(phoneOutput.id || phoneOutput.name, phone.value);

	if (document.querySelector("#registrationForm")) {
		verifyForm(document.querySelector("#registrationForm"));
		initRegistrationInputs(document.querySelectorAll('#registrationForm input'));
	}
}

const updateValuesForOutput = (el = "#registrationFormOutput") => {
	const output = document.querySelector(el);
	const allOutputs = output ? output.querySelectorAll("span.c-field-output") : null;
	const allOutputsStudentFields = output ? output.querySelectorAll("input.c-field-output") : null;
	const allOutputsCoreFields = output ? output.querySelectorAll("input.c-field-output2") : null;

	// console.log(el, allOutputsCoreFields)

	if (!allOutputs) return;

	if (allOutputsCoreFields) {
		allOutputsCoreFields.forEach(outputs => {

			if (outputs.id) {
				if (outputs.type === "checkbox") {
					if (themeActions.getLocalStorage(outputs.id.replace("_output2", ""))) {
						outputs.checked = true;
					}
				} else {
					outputs.value = themeActions.getLocalStorage(outputs.id.replace("_output2", "")) || "Not Entered";
				}
			} else {
				if (outputs.type === "checkbox") {
					if (themeActions.getLocalStorage(outputs.name.replace("_output2", ""))) {
						outputs.checked = true;
					}
				}

				if (outputs.type === "radio") {
					const value = themeActions.getLocalStorage(outputs.name.replace("_output2", ""));
					const tempOthers = document.querySelectorAll(`.c-field-output2[name="${outputs.name}"]:not([value=${value}])`)
					const temp = document.querySelectorAll(`.c-field-output2[name="${outputs.name}"][value=${value}]`)

					if (tempOthers && temp) {
						tempOthers.forEach(el => el.checked = false);
						temp.forEach(el => el.checked = true);
					}


					// if (input.name === 'attributes[are-you-a-wine-professional-or-enthusiast]' && input.checked) {
					// 	if (input.value === "Professional") {
					// 		document.querySelector('html').setAttribute('data-professional', 'true');
					// 	} else {
					// 		document.querySelector('html').removeAttribute('data-professional');
					// 	}
					// }
				}
				// outputs.value = themeActions.getLocalStorage(outputs.id.replace("_output2", "")) || "Not Entered";
			}
		});
	}

	allOutputs.forEach(outputs => {
		outputs.innerHTML = themeActions.getLocalStorage(outputs.id.replace("_output", "")) || "Not Entered";
	});

	allOutputsStudentFields.forEach(outputs => {
		outputs.value = themeActions.getLocalStorage(outputs.id.replace("_output2", "")) || "Not Entered";
	});

	// const openBtns = document.querySelectorAll('.js-modal-open');
	// if (openBtns) openBtns.forEach(btn => btn.addEventListener('click', openModal));
}

const openModal = (e) => {
	if (e) e.preventDefault();
	const registrationFormEl = document.querySelector('#registrationForm');
	if (registrationFormEl) remove(registrationFormEl, '!tw-opacity-0', '!-tw-z-10', '!tw-pointer-events-none', '!tw-select-none')
	document.querySelector('body').classList.add('tw-overflow-hidden')
}



const initRegistrationInputs = (inputs) => {
	inputs?.forEach(input => syncValues(input));
}

const registrationInputs = inputs => {
	inputs?.forEach(input => {
		switch(input.type) {
			case 'text':
			case 'email':
			case 'tel':
			input.addEventListener('input', () => syncValues(input));
				break;
			case 'radio':
			case 'checkbox':
				input.addEventListener('change', () => syncValues(input));
				break;
		}
	});
}

const syncValues = input => {
	const output = document.querySelector(`[data-id="${input.getAttribute('name')}"]`);
	if (output) {
		if (input.type === 'checkbox') {
			output.textContent = input.checked ? 'Yes' : 'No';
			output.value = input.checked ? 'Yes' : 'No';
		} else {
			output.textContent = input.value;
			output.value = input.value;
		}
	}
}

document.addEventListener('DOMContentLoaded', function() {
	const inputs = document.querySelectorAll('#registrationForm input');

	const typeOfCustomer = document.querySelector(`input.professional-type-of-customer`);

	initRegistrationInputs(inputs);
	registrationInputs(inputs);


	if (typeOfCustomer.name === 'attributes[are-you-a-wine-professional-or-enthusiast]' && typeOfCustomer.checked) {



		if (typeOfCustomer?.checked) {
			document.querySelector('html').setAttribute('data-professional', 'true');
		}
	}

	if (inputs) verifyForm(document.querySelector("#registrationForm"));

});
